import { useDefaultSubscription } from 'common/services/useDefaultSubscription'

const defaultAddress = '86-90 Paul Street\nLondon, EC2A 4NE'
export default function () {
  const { subscriptionDetail } = useDefaultSubscription()
  if (!subscriptionDetail) {
    return ''
  }
  const { location } = subscriptionDetail
  if (location) {
    return `${[location.address_line_1, location.address_line_2 || '']
      .filter((v) => !!v)
      .join(', ')}, \n${location.city}, ${location.postal_code}`
  }
  return defaultAddress
}
